import React, { useMemo } from 'react'
import styles from '../../styles/modules/Dashboard.module.css'
import DoughnutChart from '../Charts/DoughnutChart'

const DashboardDataCard = ({Icon,data,label,hint,testId}) => {
    function parseValue(val) {
        if (val == null) return 0;
        if (typeof val === "number") return val;
        if (typeof val === "string") {
            return Number(val.replace(/,/g, ""));
        }
        return Number(val) || 0;
    }

    const lastMonth = parseValue(data?.[0]);
    const currentMonth = parseValue(data?.[1]);
    const chartData = useMemo(() => [lastMonth, currentMonth], [lastMonth, currentMonth]);
    const percentage = useMemo(() => {
        if (isNaN(lastMonth) || isNaN(currentMonth)) return 0.00;
        if (lastMonth === 0) {
            if (currentMonth === 0) return 0.00;
            return 100.00;
        }
        return Number((((currentMonth - lastMonth) / lastMonth) * 100).toFixed(2));
    }, [lastMonth, currentMonth]);

    return (
        <div className={styles['dashboard_card_con']} data-testid={testId}>
            <div className={styles['dashboard_card_part_1']}>
                <Icon className={styles['dashboard_card_icon']} />
                <h1>{currentMonth}</h1>
                <h3>{label}</h3>
                {hint ? <p className={styles['dashboard_card_hint']}>{hint}</p> : null}
            </div>
            <div className={styles['dashboard_card_part_2']}>
                <DoughnutChart labels={['Last Month', 'Current Month']} chartData={chartData} height='60px' width='60px' />
               <p>+{percentage}%</p>
            </div>
        </div>
    )
}

export default DashboardDataCard
